import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";

export const secondaryIDMapping: FieldSchema = {
  name: "secondaryIDMapping",
  data: {
    assignedValue: {
      getter: (values) => {
        if (values.linkedInstance && (values.linkedInstance as LinkedInstance).secondaryIdMapping) {
          return (values.linkedInstance as LinkedInstance).secondaryIdMapping;
        }
        return null;
      },
      fields: ["linkedInstance"],
    },
  },
  form: { label: "Secondary ID Mapping", disabled: true, displayed: false },
};
